var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3 container",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},_vm._l((_vm.count),function(i){return _c('div',{class:'mt-2 ' + _vm.widthClass},[_c('tb-skeleton',{attrs:{"aspect-ratio":_vm.height}})],1)}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b84e5f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeletons/sk-cards.vue
// module id = 726
// module chunks = 1 4 5 14 20